import { AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { AdBanner } from '../../../models/ads-banner-data.model';
import { AdsBannerDataService } from '../../../services/ads-banner-data.service';
import Swiper from 'swiper';
import { catchError } from 'rxjs/operators';
import { EMPTY, of } from 'rxjs';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RxIconModule } from '@nrwl/rx-icon';
import { RxButtonModule } from '@nrwl/rx-button';

@Component({
  selector: 'ads-banner',
  templateUrl: './ads-banner.component.html',
  styleUrls: ['./ads-banner.component.scss'],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RxIconModule, RxButtonModule],
})
export class AdsBannerComponent implements OnInit, AfterViewInit, OnDestroy {
  banners: AdBanner[] = [];
  swiper: Swiper | any = null;
  autoplayIntervalId: any = null;
  DEFAULT_AD_DELAY = 5000;
  bannerPosition: string | any = 'top';
  isPrevNextVisible = true;
  hasError = false;

  constructor(private adBannerService: AdsBannerDataService) {}

  ngOnInit(): void {
    this.adBannerService
      .getAdsBannerData()
      .pipe(
        catchError((error) => {
          console.error('Error fetching ads banner data: ', error);
          this.hasError = true;
          return of([]);
        }),
      )
      .subscribe((data: AdBanner[]) => {
        if (!data.length) {
          return;
        }

        this.banners = data;
        if (this.banners.length === 1) {
          this.isPrevNextVisible = false;
        }
      });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.swiper = new Swiper('.swiper-container', {
        slidesPerView: 1,
        freeMode: false,
        loop: true,
        autoplay: {
          delay: 1000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        on: {
          init: () => {
            this.startAutoplay();
          },
          slideChange: () => {
            this.startAutoplay();
          },
        },
      });
      this.startAutoplay();
    }, 1000);
  }

  ngOnDestroy(): void {
    if (this.autoplayIntervalId) {
      clearInterval(this.autoplayIntervalId);
    }
  }

  startAutoplay(): void {
    if (!this.isPrevNextVisible) {
      return;
    }
    if (this.autoplayIntervalId) {
      clearInterval(this.autoplayIntervalId);
    }
    const delay = this.getDelay();
    this.autoplayIntervalId = setInterval(() => {
      this.swiper.slideNext();
    }, delay);
  }

  getDelay(): number {
    const currentIndex = this.swiper ? this.swiper.realIndex : 0;
    return this.banners && this.banners[currentIndex] && this.banners[currentIndex].delay
      ? this.banners[currentIndex].delay * 1000
      : this.DEFAULT_AD_DELAY;
  }

  getBannerPosition(adBanner: AdBanner) {
    switch (adBanner.position) {
      case 'top': {
        return 'column';
      }
      case 'bottom': {
        return 'column-reverse';
      }
      default: {
        return 'column';
      }
    }
  }

  onPreviousSlideClicked() {
    this.swiper.slidePrev();
  }

  onNextSlideClicked() {
    this.swiper.slideNext();
  }

  public navigateToKnowledgebase() {
    window.open('https://kb.rxphoto.com/portal/en/kb', '_blank');
  }
}
